// Service areas within ~50 miles of zip 30512 (Blairsville, Union County, GA)
const S = (s) =>
  s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

const STATE_NAMES = { GA: "Georgia", NC: "North Carolina", TN: "Tennessee" };

// [name, state, county]
const CITY_DATA = [
  ["Blairsville", "GA", "Union County"],
  ["Young Harris", "GA", "Towns County"],
  ["Hiawassee", "GA", "Towns County"],
  ["Blue Ridge", "GA", "Fannin County"],
  ["McCaysville", "GA", "Fannin County"],
  ["Mineral Bluff", "GA", "Fannin County"],
  ["Epworth", "GA", "Fannin County"],
  ["Cherry Log", "GA", "Gilmer County"],
  ["Morganton", "GA", "Fannin County"],
  ["Suches", "GA", "Union County"],
  ["Ellijay", "GA", "Gilmer County"],
  ["East Ellijay", "GA", "Gilmer County"],
  ["Jasper", "GA", "Pickens County"],
  ["Dahlonega", "GA", "Lumpkin County"],
  ["Dawsonville", "GA", "Dawson County"],
  ["Cleveland", "GA", "White County"],
  ["Helen", "GA", "White County"],
  ["Sautee Nacoochee", "GA", "White County"],
  ["Clarkesville", "GA", "Habersham County"],
  ["Cornelia", "GA", "Habersham County"],
  ["Clayton", "GA", "Rabun County"],
  ["Dillard", "GA", "Rabun County"],
  ["Sky Valley", "GA", "Rabun County"],
  ["Murphy", "NC", "Cherokee County"],
  ["Andrews", "NC", "Cherokee County"],
  ["Marble", "NC", "Cherokee County"],
  ["Hayesville", "NC", "Clay County"],
  ["Warne", "NC", "Clay County"],
  ["Brasstown", "NC", "Clay County"],
  ["Robbinsville", "NC", "Graham County"],
  ["Topton", "NC", "Macon County"],
  ["Franklin", "NC", "Macon County"],
  ["Copperhill", "TN", "Polk County"],
  ["Ducktown", "TN", "Polk County"],
  ["Turtletown", "TN", "Polk County"],
  ["Tellico Plains", "TN", "Monroe County"],
];

const COUNTY_DATA = [
  ["Union County", "GA"],
  ["Towns County", "GA"],
  ["Fannin County", "GA"],
  ["Gilmer County", "GA"],
  ["Pickens County", "GA"],
  ["Lumpkin County", "GA"],
  ["Dawson County", "GA"],
  ["White County", "GA"],
  ["Habersham County", "GA"],
  ["Rabun County", "GA"],
  ["Cherokee County", "NC"],
  ["Clay County", "NC"],
  ["Graham County", "NC"],
  ["Macon County", "NC"],
  ["Polk County", "TN"],
  ["Monroe County", "TN"],
];

export const CITIES = CITY_DATA.map(([name, state, county]) => ({
  type: "city",
  name,
  state,
  stateName: STATE_NAMES[state],
  county,
  label: `${name}, ${state}`,
  slug: `${S(name)}-${state.toLowerCase()}`,
}));

export const COUNTIES = COUNTY_DATA.map(([name, state]) => ({
  type: "county",
  name,
  state,
  stateName: STATE_NAMES[state],
  label: `${name}, ${state}`,
  slug: `${S(name)}-${state.toLowerCase()}`,
}));

export const STATES = Object.entries(STATE_NAMES).map(([abbr, name]) => ({
  type: "state",
  name,
  state: abbr,
  stateName: name,
  label: name,
  slug: S(name),
}));

export const ALL_LOCATIONS = [...CITIES, ...COUNTIES, ...STATES];

export const getLocation = (slug) =>
  ALL_LOCATIONS.find((l) => l.slug === slug) || null;

export const getRelated = (loc) => {
  if (loc.type === "city") {
    const county = COUNTIES.find(
      (c) => c.name === loc.county && c.state === loc.state
    );
    const nearby = CITIES.filter(
      (c) => c.state === loc.state && c.name !== loc.name
    ).slice(0, 9);
    return [...(county ? [county] : []), ...nearby];
  }
  if (loc.type === "county") {
    const cities = CITIES.filter(
      (c) => c.county === loc.name && c.state === loc.state
    );
    const state = STATES.find((s) => s.state === loc.state);
    return [...cities, ...(state ? [state] : [])];
  }
  // state
  return COUNTIES.filter((c) => c.state === loc.state);
};
